import type { ReactNode } from "react";

import FirstUseHint from "components/first-use-hint/first-use-hint.component";

import { MENTIONS_LAUNCH_KEYS } from "./mentions-launch";
import useMentionsLaunchUserId from "./use-mentions-launch-user-id.hook";

/**
 * The launch hint on a task comment box: a pulsing dot, and a card that opens while the box has
 * focus. Off (flag off, no user yet): the children exactly as they were, with no wrapper.
 */
export default function MaybeMentionsCommentHint({
  children
}: {
  children: ReactNode;
}) {
  const userId = useMentionsLaunchUserId();
  if (!userId) return <>{children}</>;
  return (
    <FirstUseHint
      storageKey={MENTIONS_LAUNCH_KEYS.commentBox}
      userId={userId}
      testId="mentions-comment"
      title="Need a teammate's input?"
      body="Type @ and a name in a comment or the task description. They are notified when you save, and can find the task under Home → Tasks → Mentioned Me."
      datadogActions={{
        shown: "mentions_comment_hint_shown",
        dismissed: "mentions_comment_hint_dismissed"
      }}
    >
      {children}
    </FirstUseHint>
  );
}
